import { apiClient } from '../client'
import type { ApiResponse } from '../client.types'
import type { FlagRead } from '../types'

/**
 * Config API endpoints
 * GET /config/flags - List all flags
 * GET /config/flags/{flag_name} - Get specific flag
 */

export const configApi = {
  /**
   * Get all feature flags
   * GET /config/flags
   */
  getAllFlags(): Promise<ApiResponse<FlagRead[]>> {
    return apiClient.get<FlagRead[]>('/config/flags')
  },

  /**
   * Get specific feature flag
   * GET /config/flags/{flag_name}
   */
  getFlag(flagName: string): Promise<ApiResponse<FlagRead>> {
    return apiClient.get<FlagRead>(`/config/flags/${encodeURIComponent(flagName)}`)
  },
}
